import { FC } from 'react';
import styled from 'styled-components';
import SelectionBulkContainer from '../../../shop/selectionlists/header/SelectionBulkContainer';
import SelectionBulkMenu from '../../../shared/components/SelectionBulkMenu';
import { LibraryManagedProductGroupOnSiteOut } from '../../../store/api-catman';
import { Orderlist } from '../../../../models/OrderList';
import { ProductSelectionState } from '../../../store/productSelection/state';
import { useTranslation } from 'react-i18next';
import { BulkAddProductsToSelectionListResponse, BulkAddProductsToShoppingCartResponse } from '../../../store/api';

const StBreadcrumbs = styled.ul`
    display: flex;
    font-size: 16px;
`;

interface Props {
    isInSelectionMode: boolean;
    isSticky: boolean;
    productSelection: ProductSelectionState;
    deselectAll: () => void;
    onBulkAddToList: (orderlist: Orderlist, performChecks: boolean) => Promise<BulkAddProductsToSelectionListResponse>;
    onBulkAddToCart: (performChecks: boolean) => Promise<BulkAddProductsToShoppingCartResponse>;
    onBulkAddToGroup: (productGroupId: number) => void;
    cancelSelectionMode: () => void;
    productGroups: LibraryManagedProductGroupOnSiteOut[];
}

export const NewlyAddedHeader: FC<Props> = props => {
    const { t } = useTranslation();
    const {
        isInSelectionMode,
        isSticky,
        deselectAll,
        onBulkAddToList,
        onBulkAddToCart,
        onBulkAddToGroup,
        cancelSelectionMode,
        productGroups
    } = props;

    const bulkMenu = (
        <SelectionBulkMenu
            isInSelectionMode={isInSelectionMode}
            isSticky={isSticky}
            cancelSelection={cancelSelectionMode}
            selectedCount={props.productSelection?.count}
            onBulkAddToCart={onBulkAddToCart}
            onBulkAddToList={onBulkAddToList}
            onBulkAddToGroup={onBulkAddToGroup}
            deselectAll={deselectAll}
            deleteLabel={t('deleteFromList')}
            productGroups={productGroups}
            isAddToCartEnabled={true}
            isAddToListEnabled={true}
            isAddToProductGroupEnabled={true}
        />
    );

    const header = (
        <div>
            <StBreadcrumbs>
                <li>
                    <i className="bolinda-icons" style={{ fontSize: 'inherit', marginRight: '0.3em' }}>
                        your_collection
                    </i>
                </li>
                <li>{t('menu.yourBorrowbox.yourCollectionMain')}</li>
                <li className="material-icons md-big">keyboard_arrow_right</li>
                <li>{t('menu.yourBorrowbox.yourCollection.newlyAdded')}</li>
            </StBreadcrumbs>
        </div>
    );

    return (
        <SelectionBulkContainer
            movedUp={isInSelectionMode}
            isSticky={isSticky}
            headerComponent={header}
            bulkMenuComponent={bulkMenu}
            headerHeight={64}
        />
    );
};
